import styled from 'styled-components';



const DialogFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: 4px;
`;



export default DialogFooter;
